import * as React from 'react';

import {Basic} from './Basic.story';
import {ButtonWithIcon} from './ButtonWithIcon.story';
import {Color} from './Color.story';
import {CurrentColor} from './CurrentColor.story';
import {Size} from './Size.story';
import {EveryIcon} from './EveryIcon.story';

const basic = {
  rendered: <Basic />,
  source: `<Icon name="addCircle" />`,
};

const buttonWithIcon = {
  rendered: <ButtonWithIcon />,
  source: `<Button>
  <Box css={{layout: 'row', gap: 75, alignY: 'center'}}>
    <Icon name="mobile" size="xsmall" />
    <Inline>New messages</Inline>
  </Box>
</Button>
<Badge type="positive">
  <Icon name="mobile" size="xsmall" />
  New messages
</Badge>`,
};

const color = {
  rendered: <Color />,
  source: `<Icon name="cancelCircle" css={{fill: 'critical'}} />`,
};

const currentColor = {
  rendered: <CurrentColor />,
  source: `<Inline css={{color: 'attention'}}>
  <Icon name="mobile" /> new messages
</Inline>`,
};

const size = {
  rendered: <Size />,
  source: `<Icon name="konbini" size="xsmall" />
<Icon name="konbini" size="small" />
<Icon name="konbini" size="medium" />
<Icon name="konbini" size="large" />
<Icon name="konbini" size="xlarge" />`,
};

const everyIcon = {
  rendered: <EveryIcon />,
  source: `<Icon name="add" />`,
};

export const IconExamples = {
  basic,
  buttonWithIcon,
  color,
  currentColor,
  size,
  everyIcon,
};
